import { Box3, Object3D } from 'three'

/**
 * GLBs de mano izquierda (*I) se exportan a menudo con scale.x < 0 (espejo).
 * Eso deja el AABB en X negativo (p.ej. KBRB8010040I → −1000…0 mm), mientras
 * los hijos API (encimera/zócalo/tirador) viven en X positivo → quedan al lado.
 *
 * Importante: SceneObjectRenderer solo monta `object.children` (ObjectGroup con
 * position/scale del nodo). Mover `root.position` no se ve en pantalla; hay que
 * desplazar el nodo con scale.x < 0.
 */
export function normalizeMirroredGlbScene(root: Object3D | null | undefined): boolean {
  if (!root) return false

  const mirroredChild =
    root.scale.x < 0
      ? root
      : root.children.find((child) => child.scale.x < 0) ??
        (() => {
          let found: Object3D | undefined
          root.traverse((obj) => {
            if (!found && obj !== root && obj.scale.x < 0) found = obj
          })
          return found
        })()

  if (!mirroredChild) return false

  root.updateMatrixWorld(true)
  const box = new Box3().setFromObject(root)
  if (box.isEmpty()) return false

  const minX = box.min.x
  // Solo volúmenes claramente en −X (no ruido ni objetos que cruzan 0).
  if (minX >= -1e-4) return false
  if (box.max.x > 1e-3) return false

  mirroredChild.position.x += -minX
  root.updateMatrixWorld(true)
  return true
}
